
(function() {
  // Ensure DOM is ready
  function onReady(callback) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }

  // Wait for element to appear
  function waitForElement(selector, callback, timeout = 10000) {
    const el = document.querySelector(selector);
    if (el) return callback(el);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });

    const body = document.body;
    if (body) {
      observer.observe(body, { childList: true, subtree: true });
      if (timeout) setTimeout(() => observer.disconnect(), timeout);
    }
  }

  // Main logic
  onReady(() => {
    waitForElement('.limoniapps-notification li', (li) => {
      const notif = li.closest('.limoniapps-notification');
      const ul = notif ? notif.querySelector('.limoniapps-message-body ul') : null;
      if (!ul) return;

      // Convert <li> tags to <div> tags
      const html = ul.innerHTML
        .replaceAll(/<li/g, '<div')
        .replaceAll(/<\/li>/g, '</div>');

      const productForm = document.querySelector('#product-form-container');
      if (!productForm) return;

      // Find or create .discount-message after #product-form
      let discountMsg = document.querySelector('.discount-message');
      if (!discountMsg) {
        discountMsg = document.createElement('div');
        discountMsg.className = 'discount-message';
        productForm.insertAdjacentElement('afterend', discountMsg);
      }

      discountMsg.innerHTML = html;

      // Hide the original notification
      notif.classList.add('hidden');
    });

    const primaryButton = document.querySelector('.guard-fit-button');
    const container = document.querySelector('#product-form-container');
    
    if(container){
      const secondaryButton = container.shadowRoot.querySelector(
        '.guard-fit-button-second'
      );


      secondaryButton.addEventListener('click', function (e) {
        e.preventDefault();
        primaryButton.click();
      });



      const odOverlay = document.getElementById('OdOverlay');
      const odOpenElements = container?.shadowRoot ? container.shadowRoot.querySelectorAll('.od-info-link') : [];
      const odCloseX = document.getElementById('OdCloseX');

      function odOpen(){
        odOverlay.dataset.open = "true";
        odOverlay.setAttribute("aria-hidden", "false");
        // lock background scroll
        document.body.style.overflow = "hidden";
      }

      function odClose(){
        odOverlay.dataset.open = "false";
        odOverlay.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
        // quick reset so animation replays next open
        const odModal = odOverlay.querySelector('.od-modal');
        odModal.style.animation = "none";
        // force reflow
        void odModal.offsetHeight;
        odModal.style.animation = "";
      }

      // Attach click event to all elements with .input-opening-direction class
      odOpenElements.forEach(element => {
        element.addEventListener('click', odOpen);
      });

      odCloseX.addEventListener('click', odClose);

      // close on overlay click (but not when clicking modal)
      odOverlay.addEventListener('click', (e) => {
        if(e.target === odOverlay) odClose();
      });

      // close on Esc
      window.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && odOverlay.dataset.open === "true") odClose();
      });

    }
    

    
  });
})();



